import React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import AccountCircle from "@mui/icons-material/AccountCircle";
import _ from "lodash";

export const AccountMenuButton = ({ menuId, onClick }) => {
  return (
    <Box
      sx={{
        display: {
          xs: "flex",
          md: "flex",
        },
        background: "#fff",
        height: "100%",
        paddingRight: "15px",
      }}
    >
      <IconButton
        size="large"
        edge="end"
        aria-label="account of current user"
        aria-controls={menuId}
        aria-haspopup="true"
        onClick={onClick}
        color="inherit"
      >
        <AccountCircle />
      </IconButton>
    </Box>
  );
};